export const isAccept = (
  file: { name: string; type?: string },
  accept: string | undefined,
): boolean => {
  if (!accept) return true;

  return accept
    .split(",")
    .map((s) => s.trim())
    .some((item) => isSingleAccept(item, file.name, file.type));
};

// Формат элемента accept соответствует стандарту:
// https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Attributes/accept#unique_file_type_specifiers
// 1. A valid case-insensitive filename extension, starting with a period (".") character. For example: .jpg, .pdf, or .doc.
// 2. A valid MIME type string, with no extensions.
// 3. The string audio/* meaning "any audio file".
// 4. The string video/* meaning "any video file".
// 5. The string image/* meaning "any image file".

export const isSingleAccept = (
  acceptItem: string,
  fileName: string,
  fileType?: string,
): boolean => {
  // (1)
  if (acceptItem[0] === ".") {
    const rx = new RegExp(acceptItem.replace(".", "\\."), "i");
    return rx.test(fileName);
    // Для JPEG-файлов есть несколько общепринятых расширений: .jpeg, .jpg и даже .jfif
    // Однако, здесь это пока никак не учитывается.
    // То есть, либо нужно явно указать все эти случаи в accept, либо указать image/jpeg
  }
  // (2)
  if (acceptItem.toLowerCase() === fileType) {
    return true;
  }
  // (3,4,5)
  if (fileType) {
    if (
      (acceptItem === "image/*" && /^image\//.test(fileType)) ||
      (acceptItem === "video/*" && /^video\//.test(fileType)) ||
      (acceptItem === "audio/*" && /^audio\//.test(fileType))
    ) {
      return true;
    }
  }
  return false;
};
// Если указать тип accept файла (н.р. ".png"), то будет проверка по имени файла
// Если указать mime, то будет проверка по типу файла
